var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n    "+_vm._s(_vm.$t('rubinred.ecommerce.orders.checkout.bank'))+": "+_vm._s(_vm.bank)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fba547e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/payment/GestpayMybankSummary.vue
// module id = 5+4s
// module chunks = 0